import { IRights } from "../../interfaces/Rights";

export const SET_LOADING = "SET_LOADING";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const LOGIN = "LOGIN";
export const CHANGE_COMPANY = "CHANGE_COMPANY";


const initialState = {
  isAuthenticated: false,
  email: "",
  companyId: -1,
  companyName: "",
  role: "",
  rights: new Array<IRights>(),
};

interface AuthState {
    email: string;
    isAuthenticated: boolean;
    companyId: number;
    role: string;
    companyName: string;
    rights: IRights[];
}
export interface AuthAction {
    type: 
    | typeof LOGIN
    | typeof AUTH_LOGOUT
    | typeof CHANGE_COMPANY;
    email?: string;
    isAuthenticated?: boolean;
    companyId?: number;
    role?: string;
    companyName?: string;
    rights?: IRights[];
}

export const AuthReducer = (state: AuthState = initialState, action: AuthAction): AuthState => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        email: action.email || "",
        isAuthenticated: action.isAuthenticated || false,
        // companyId: action.companyId || -1,
        // role: action.role || "",
        // companyName: action.companyName || "",
        rights: action.rights || [],
      };
    case CHANGE_COMPANY:
      return {
        ...state,
        companyId: action.companyId === undefined ? -1 : action.companyId,
        companyName: action.companyName || "",
        role: action.role || "",
      };
    case AUTH_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
